"use client";

import { createContext, useContext, useMemo, useState, type ReactNode } from "react";

type PieceContextValue = {
  itemSize: string;
  /** The size the visitor wants instead of itemSize. Empty when they want the original. */
  requestedSize: string;
  setRequestedSize: (next: string) => void;
};

const PieceContext = createContext<PieceContextValue | null>(null);

export function PieceProvider({ itemSize, children }: { itemSize: string; children: ReactNode }) {
  const [requestedSize, setRequestedSize] = useState("");
  const value = useMemo(
    () => ({ itemSize: itemSize.trim(), requestedSize, setRequestedSize }),
    [itemSize, requestedSize]
  );
  return <PieceContext.Provider value={value}>{children}</PieceContext.Provider>;
}

export function usePieceContext(): PieceContextValue {
  return useContext(PieceContext) ?? { itemSize: "", requestedSize: "", setRequestedSize: () => {} };
}
